import authenticationApi from 'apis/authentication';

export const updateAuthenticationReviewStatus = async (
  authenticationBagId: number,
  isFakeBag: boolean,
) => {
  const detail = await authenticationApi.getAuthenticationDetail(
    String(authenticationBagId),
  );
  const authenticationResultId = detail?.latestResult?.id;

  if (!authenticationResultId) {
    throw new Error('Authentication result not found');
  }

  const targetReviewStatus = isFakeBag ? 'fake' : 'genuine';
  if (detail?.latestResult?.reviewStatus === targetReviewStatus) {
    return;
  }

  await authenticationApi.updateReviewStatus({
    id: authenticationResultId,
    reviewStatus: targetReviewStatus,
  });
};
